import type { TodoState } from '@erikdakoda/database/enums';
import type { IconPrefix } from '@erikdakoda/ui/components/FaIconUvilo';

export type TodoStateMeta = {
  label: string;
  icon: string;
  prefix: IconPrefix;
  /** MUI palette color path for FaIconUvilo sx.color */
  color: 'text.primary' | 'warning.main' | 'error.main' | 'success.main';
};

export const TODO_STATE_META: Record<TodoState, TodoStateMeta> = {
  empty: { label: 'Empty', icon: 'square', prefix: 'fal', color: 'text.primary' },
  started: { label: 'Started', icon: 'square', prefix: 'fal', color: 'warning.main' },
  unverified: {
    label: 'Unverified',
    icon: 'square-exclamation',
    prefix: 'fal',
    color: 'warning.main',
  },
  blocked: { label: 'Blocked', icon: 'light-square-stop', prefix: 'far', color: 'error.main' },
  done: { label: 'Done', icon: 'square-check', prefix: 'fal', color: 'success.main' },
};

export const TODO_STATE_ORDER: TodoState[] = ['empty', 'started', 'unverified', 'blocked', 'done'];

/** Sidebar icons for todo lists by group. */
export const TODO_LIST_GROUP_ICONS: Record<string, string> = {
  user: 'clipboard-check',
  coach: 'whistle',
  agent: 'robot',
};

/**
 * Derives the sidebar "Done" section title from a user todo list name
 * (e.g. "Erik Todos" → "Erik Done").
 */
export function getTodoListDoneSectionName(listName: string): string {
  if (/todos?/i.test(listName)) {
    return listName.replace(/todos?/i, 'Done');
  }
  return `${listName} Done`;
}
